import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Slider } from "@/components/ui/slider";
import { inr } from "@/lib/format";
import { useKiosk } from "./KioskContext";

export const exchangeRange = (rules, type, age, condition) => {
  const base = rules.base[type];
  const v = Math.max(base * Math.pow(1 - rules.depreciation_pct / 100, age) * rules.condition[condition], (base * rules.floor_pct) / 100);
  const r = (x) => Math.round(x / 500) * 500;
  return [r(v * 0.92), r(v * 1.08)];
};

const Seg = ({ items, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-2" data-testid={testid}>
    {items.map(([k, l]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
        className={`min-h-[56px] rounded-full px-6 text-[17px] font-medium transition-colors ${value === k ? "bg-[#1D1D1F] text-white" : "bg-[#F5F5F7]"}`}>{l}</button>
    ))}
  </div>
);

export default function Exchange() {
  const { data, t, logEvent } = useKiosk();
  const [type, setType] = useState("Motorcycle");
  const [age, setAge] = useState(4);
  const [cond, setCond] = useState("good");
  const [lo, hi] = exchangeRange(data.settings.exchange, type, age, cond);
  useEffect(() => { logEvent("exchange"); }, [logEvent]);

  return (
    <main className="mx-auto grid max-w-[1200px] gap-10 px-6 pb-12 pt-6 lg:grid-cols-[1.1fr_1fr] lg:px-10 pk:!grid-cols-1 pk:!pt-12 pk:!min-h-[calc(100dvh-140px)] pk:!content-center" data-testid="exchange-page">
      <div className="flex flex-col gap-8">
        <div>
          <p className="text-[17px] font-semibold text-[#087568]">{t("exchange")}</p>
          <h1 className="font-display mt-1 text-5xl lg:text-[60px] font-extrabold leading-none tracking-[-0.045em]">{t("exTitle")}</h1>
        </div>
        <div><p className="mb-3 text-[15px] font-medium text-[#6E6E73]">{t("exType")}</p>
          <Seg testid="ex-type" value={type} onChange={setType} items={[["Motorcycle", t("cat_Motorcycle")], ["Scooter", t("cat_Scooter")]]} /></div>
        <div>
          <div className="mb-4 flex justify-between text-[15px]"><span className="font-medium text-[#6E6E73]">{t("exAge")}</span><span className="font-semibold tnum" data-testid="ex-age">{age} {t("years")}</span></div>
          <Slider className="kiosk-slider" value={[age]} min={0} max={15} step={1} onValueChange={(v) => setAge(v[0])} data-testid="ex-age-slider" />
        </div>
        <div><p className="mb-3 text-[15px] font-medium text-[#6E6E73]">{t("exCondition")}</p>
          <Seg testid="ex-cond" value={cond} onChange={setCond} items={[["excellent", t("excellent")], ["good", t("good")], ["fair", t("fair")]]} /></div>
      </div>
      <div className="tile flex flex-col justify-between p-9">
        <div>
          <p className="text-[15px] font-medium text-[#6E6E73]">{t("exValue")}</p>
          <p className="font-display mt-4 text-4xl lg:text-[52px] font-extrabold leading-none tracking-[-0.045em] tnum" data-testid="ex-value">{inr(lo)} – {inr(hi)}</p>
          <p className="mt-4 text-[14px] text-[#6E6E73]">{t("exNote")}</p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/kiosk/quiz" className="btn-pill btn-ink" data-testid="ex-quiz-btn">{t("findRide")}</Link>
          <Link to="/kiosk/book/quote" className="btn-pill btn-teal" data-testid="ex-quote-btn">{t("getQuote")}</Link>
        </div>
      </div>
    </main>
  );
}
